// import logo from './logo.svg';
import './App.css';
// import { render } from "react-dom";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
// import Header from './Header';
// import Sidebar from './components/Sidebar';
import Chat from './components/chat/Chat';
import Login from './components/auth/Login';
import MainChat from '../src/components/chat/parentChat/MainChat';
import GlobalVarProvider from './components/Provider/GlobalVarProvider';
import ProtecttedRout from './components/protecttedRout/ProtecttedRout';
import I18nProvider from './components/Provider/I18nProvider';
import UIProvider from './components/Provider/UIProvider';
import ChildForgotPassword from './components/Outerpage/ChildForgotPassword';
import ChildResetPassword from './components/Outerpage/ChildResetPassword';
import ChildSuccessNumberChange from './components/Outerpage/SuccessNumberChange';
import ChildConfirmOtp from './components/Outerpage/ChildConfirmOtp';

function App() {

  return (
   <>
      <BrowserRouter>
        <I18nProvider>
          <UIProvider>
            <GlobalVarProvider>
              <Routes>
                <Route path ="/" element={<Login/>}/>
                <Route path ="/forgotpassword" element={<ChildForgotPassword/>}/>
                <Route path="/otp" element={<ChildConfirmOtp />} />
                <Route path="/resetpassword" element={<ChildResetPassword />} />
                <Route path="/passwordchange" element={<ChildSuccessNumberChange />} />
                <Route element={<ProtecttedRout />}>
                  <Route path ="/home" element={<MainChat/>}/>
                  <Route path ="/chat" element={<Chat />}/>
                </Route>
              </Routes>
              </GlobalVarProvider>
          </UIProvider>  
        </I18nProvider>
        </BrowserRouter>
   </>
  );
}

export default App;




